// COMPONENT IMPORTS
import { apiInstance } from "store/api/axiosApi";
import {
  FORGOT_PASSWORD,
  GET_ACCOUNT_DETAILS,
  GET_EMAIL_IDS,
  GET_PHONE_NUMBERS,
  LOGIN,
  GOOGLE_LOGIN,
  REQUEST_ACCESS,
  RESET_PASSWORD,
  SEND_VERIFICATION,
  CHANGE_CONTACT_OTP,
  SET_PASSWORD,
  SIGN_UP,
  SIGN_UP_GET_ACCOUNT,
  VERIFY_OTP,
  UPDATE_PHONE,
  UPDATE_EMAIL,
  UPDATE_ACCOUNT,
  GET_NOTIFICATION,
  NOTIFICATION_READ,
  UPDATE_PROFILE_PICTURE,
  CHECKTOKEN,
  REFRESHTOKEN,
  GET_PROFILE_PICTURE,
  GET_FINANCIAL_SETTINGS,
  ACCOUNT_PERMISSION,
  ADD_NOTIFICATION,
  GET_CUSTOMER_DETAILS,
  GET_ACCOUNT_ATTACH_MULTIPLE,
  GET_NOTIFICATION_COUNT,
} from "store/api/constApi";

/* ------------------------------------- AUTH SERVICES ------------------------------------- */

export const getAccountDetails = (params: any) => {
  return apiInstance.get(GET_ACCOUNT_DETAILS, { params });
};

export const login = (payload: any) => {
  return apiInstance.post(LOGIN, payload);
};

export const googleLogin = (payload: any) => {
  return apiInstance.post(GOOGLE_LOGIN, payload);
};

export const getPhoneNumbers = (params: any) => {
  return apiInstance.get(GET_PHONE_NUMBERS, { params });
};

export const getEmailIds = (params: any) => {
  return apiInstance.get(GET_EMAIL_IDS, { params });
};

export const verificationSend = (payload: any) => {
  return apiInstance.post(SEND_VERIFICATION, payload);
};

export const contactOtpSend = (payload: any) => {
  return apiInstance.post(CHANGE_CONTACT_OTP, payload);
};

export const updatePhone = (payload: any) => {
  return apiInstance.post(UPDATE_PHONE, payload);
};

export const updateEmail = (payload: any) => {
  return apiInstance.post(UPDATE_EMAIL, payload);
};

export const updateAccountData = (payload: any) => {
  return apiInstance.post(UPDATE_ACCOUNT, payload);
};

export const verifyOtp = (payload: any) => {
  return apiInstance.post(VERIFY_OTP, payload);
};

export const getSignUpDetails = (params: any) => {
  return apiInstance.get(SIGN_UP_GET_ACCOUNT, { params });
};

export const userSignUp = (payload: any) => {
  return apiInstance.post(SIGN_UP, payload);
};

// Setting or resetting a password is authorised by the token OTP verification
// returns, since the customer is not logged in yet.
const withOtpToken = (otpToken?: string) =>
  otpToken ? { headers: { Authorization: `Bearer ${otpToken}` } } : undefined;

export const setNewPassword = (payload: any, otpToken?: string) => {
  return apiInstance.post(SET_PASSWORD, payload, withOtpToken(otpToken));
};

export const forgotPassword = (payload: any) => {
  return apiInstance.post(FORGOT_PASSWORD, payload);
};

export const resetPassword = (payload: any, otpToken?: string) => {
  return apiInstance.post(RESET_PASSWORD, payload, withOtpToken(otpToken));
};

export const requestAccess = (payload: any) => {
  return apiInstance.post(REQUEST_ACCESS, payload);
};

export const getNotification = (params: any) => {
  return apiInstance.get(GET_NOTIFICATION, { params });
};

export const getNotificationCount = (params: any) => {
  return apiInstance.get(GET_NOTIFICATION_COUNT, { params });
};

export const readNotification = (payload: any) => {
  return apiInstance.post(NOTIFICATION_READ, payload);
};

export const getAccountPermission = (params: any) => {
  return apiInstance.get(ACCOUNT_PERMISSION, { params });
};

export const getCustomerDetail = (params: any) => {
  return apiInstance.get(GET_CUSTOMER_DETAILS, { params });
};

export const addActivity = (payload: any) => {
  return apiInstance.post(ADD_NOTIFICATION, payload);
};

export const uploadProfilePicture = (payload: any) => {
  return apiInstance.post(UPDATE_PROFILE_PICTURE, payload);
};

export const getProfilePicture = (params: any) => {
  return apiInstance.get(GET_PROFILE_PICTURE, { params });
};

export const checkToken = (params: any) => {
  return apiInstance.get(CHECKTOKEN, { params });
};

export const refreshToken = (params: any) => {
  return apiInstance.get(REFRESHTOKEN, { params });
};

export const getFinancialSettings = (params: any) => {
  return apiInstance.get(GET_FINANCIAL_SETTINGS, { params });
};

export const getAccountAttach = (payload: any) => {
  return apiInstance.post(GET_ACCOUNT_ATTACH_MULTIPLE, payload);
};
